import { v4 as uuidv4 } from "uuid";
export class EntryActionComboModel {
    constructor() {
        this.id = uuidv4();
        this.referenceNumber = "";
        this.description = "";
        this.referenceLink = "";
        this.whyItMatters = "";
        this.amendments = "";
        this.stateId = "";
        this.typeId = "";
        this.dateOpenedAsString = "";
        this.upComingEvents = [];
        this.entryActions = [];
        this.entryTags = [];
        this.entryCategories = [];
        this.isNeedSubmit = false;
        this.entryStatus = "";
    }
}
export default class EntryActionCombo extends EntryActionComboModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
